import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { CardDashboardTradesLoading } from '../card-loading/card-dashboard-trades-loading';
import { ValueAmount } from '../../../../value/amount/value-amount';
import { CardTitle } from '../../../title/card-title';
import { ValueDescription } from '../../../value-description/value-description';

export const CardDashboardTradesAllTime: React.FC = observer(() => {
    const { t } = useTranslation();

    const rootStore = useRootStore();
    const { portfolioStore, statisticStore } = rootStore;
    const { overviewStore } = statisticStore;

    const { overview } = overviewStore;

    const portfolioCurrency = portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode;

    return (
        <CardDashboardTradesLoading fields={['totalPortfolioValue']}>
            <div className="relative flex h-full min-h-[15rem] flex-col items-start justify-between overflow-hidden rounded-large bg-surface bg-[url('/images/card-stats/all-time-bg.svg')] bg-[length:auto_90%] bg-[position:102%_300%] bg-no-repeat p-[1.6rem] shadow-strong lg:p-[2.2rem] max-md:bg-[length:auto_10rem] max-md:bg-[position:102%_110%]">
                <div>
                    <CardTitle
                        title={t('layout.statisticsCard.allTime.title')}
                        tooltip={t('layout.statisticsCard.allTime.tooltip')}
                    />
                </div>
                {overview && (
                    <ValueDescription
                        value={
                            <ValueAmount
                                amount={
                                    overview.totalPortfolioValue +
                                    statisticStore.ratiosStore.unrealizedTodayProfit.totalTodayProfit
                                }
                                currency={portfolioCurrency}
                                mode="pure"
                                hidable
                            />
                        }
                        padding={'none'}
                        valueColor={'secondary'}
                    />
                )}
            </div>
        </CardDashboardTradesLoading>
    );
});
